import React from 'react';
import { xs_isMobile } from '../..';
import { getEnv } from '../env';
import { isLoadedInIframe } from '../utils';

export default function SocialButtons(props) {
    const text = `${props.message} ${window.encodeURIComponent(props.ticketUrl)}`.replace(/ /g, '%20');
    const whatsappUrl = xs_isMobile ? `whatsapp://send?text=${text}` : `https://web.whatsapp.com/send?text=${text}`;
    const telegramUrl = `https://t.me/share/url?url=${props.ticketUrl}&text=${props.message}`;

    return (
        <>
            <div id="whatsapp">
                <a href={whatsappUrl} target={`${isLoadedInIframe() ? '_system' : '_self'}`} >
                    <img src={`${getEnv('PUBLIC_URL')}/assets/images/whatsapp.svg`} height="32px" width="32px" alt="Whatsapp share button" />
                </a>
            </div>
            <div id="telegram">
                <a href={telegramUrl} target={`${isLoadedInIframe() ? '_system' : '_self'}`}>
                    <img src={`${getEnv('PUBLIC_URL')}/assets/images/telegram.svg`} height="32px" width="32px" alt="Telegram share button" />
                </a>
            </div>
        </>
    );
}
